module.exports = __webpack_public_path__ + "img/a12.af88cd2f.png";